import { createContext } from "react";
import { IFilterDataProcedimientos } from "../../../gateways/procedimientos.interfaces";

export const FilterDataContext = createContext<IFilterDataProcedimientos>({ });